import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';
import { User } from '@common/models';
import { Column, DataTableInput, DataTableOutput, Order, PagedData, Search } from '@core/models/datables';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  private columns: Column[] = [
    {
      data: "id",
      name: "ID",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "person.name",
      name: "Name",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "email",
      name: "Email",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "createdAt",
      name: "Date",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "status.name",
      name: "Status",
      searchable: true,
      orderable: true,
      search: {
        regex: true,
        value: "Activo+Inactivo"
      }
    }
  ];

  /**
   * Get all users
   */
  getAll(page: number, quantity: number) {
    return this._http.get<PagedData<User>>(`${environment.commonApiUrl}/api/users/page/${page}/${quantity}`);
  }

  getAllUsers(page: number, quantity: number, order: Order, searchText: string){
    const input = this.createDataTableInput(page, quantity, order, searchText);
    return this._http.post<DataTableOutput<User>>(`${environment.commonApiUrl}/api/users/index`, input);
  }

  /**
   * Get user by id
   */
  getById(id: number) {
    return this._http.get<User>(`${environment.commonApiUrl}/api/users/${id}`);
  }

  getFilteredUsers(){
    return this._http.get<User[]>(`${environment.commonApiUrl}/api/users`);
  }

  getByNameLite(filterText: string){
    return this._http.get<User[]>(`${environment.commonApiUrl}/api/users/lite/${filterText}`);
  }

  addUser(user){
    return this._http.post<User>(`${environment.commonApiUrl}/api/users`, user).pipe(
      map((response: any) => response.user as User),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  editUser(user){
    return this._http.put<User>(`${environment.commonApiUrl}/api/users/${user.id}`, user).pipe(
      map((response: any) => response.user as User),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  changeStatus(id: number, newStatusCode: string) {
    return this._http.put<User>(`${environment.commonApiUrl}/api/users/${id}/${newStatusCode}`,{}).pipe(
      map((response: any) => response.user as User),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  changePassword(user: User) {
    return this._http.put<User>(`${environment.commonApiUrl}/api/users/pass/${user.id}`,user).pipe(
      map((response: any) => response.user as User),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  private createDataTableInput(page: number, quantity: number, order: Order, searchText: string): DataTableInput{
    let input = new DataTableInput();
    input.start = page * quantity;
    input.length = quantity;
    if (searchText !== ''){
      input.search.regex = true;
      input.search.value = searchText;
    }
    if(order){
      input.order.push(order);
    }
    input.columns = this.columns;
    return input;
}
  
}
